import { css } from 'styled-components';
import { COLORS } from 'utils/variables';

export default css`
    color: ${COLORS.ALERT_RED};
    font-size: 14px;
`;
